import { useState } from "react";

const RetryOrder = ({ id, setRetryOrderId }) => {
  const [isBusy, setIsBusy] = useState(false);
  const [response, setResponse] = useState(null);
  const token = localStorage.getItem("token");

  const retryDispatch = () => {
    id &&
      axios
        .get(
          `${process.env.REACT_APP_API_ENDPOINT}order/retry-dispatch?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          if (res.data.code === 1) {
            setResponse({ type: "success", message: res?.data?.message });
          } else {
            setResponse({ type: "error", message: res?.data?.message });
          }
          setRetryOrderId(null);
          setTimeout(() => setResponse(null), 5000);
          setIsBusy(false);
        })
        .catch((error) => {
          setResponse({ type: "error", message: "Something went wrong." });
          setRetryOrderId(null);
          setTimeout(() => setResponse(null), 5000);
          setIsBusy(false);
          console.log(error);
        });
  };

  return (
    <>
      <div
        className={
          id && response === null ? "modal fade show d-block" : "modal fade"
        }
        tabIndex={-1}
        id="kt_modal_1"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content text-center">
            <div className="modal-header">
              <h5 className="modal-title mx-auto">RETRY</h5>
            </div>
            <div className="modal-body">
              <p className="h4">Are You Sure ?</p>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                onClick={() => {
                  setRetryOrderId(null);
                }}
                type="button"
                className="btn btn-light btn-sm"
                data-bs-dismiss="modal"
                disabled={isBusy ?? false}
              >
                No
              </button>
              <button
                disabled={isBusy ?? false}
                type="button"
                className="btn btn-light btn-sm"
                onClick={() => {
                  setIsBusy(true);
                  retryDispatch();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          id === null && response ? "modal fade show d-block" : "modal fade"
        }
        tabIndex={-1}
        id="kt_modal_1"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content text-center">
            <div className="modal-body p-4">
              {response?.type === "error" && (
                <>
                  <i className="ki-duotone ki-cross-circle fs-5x text-danger my-5">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                  <p className="h6 mt-5 text-danger">
                    {response?.message ?? ""}
                  </p>
                </>
              )}
              {response?.type === "success" && (
                <>
                  <i className="ki-duotone ki-check-circle fs-5x text-success my-5">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                  <p className="h6 mt-5 text-success">
                    {response?.message ?? ""}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RetryOrder;
